<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-1">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" option="Last 30 days" hide-details/>
        </v-col>
        <v-col cols="3">
          <inventory-categories-select v-model="categoryId" label="Category" type="Item" none-text="All" @change="refresh()" hide-details/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Show" :items="['Quantity','Value']" outlined dense hide-details v-model="show"/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="By" :items="['Date','Item']" outlined dense hide-details v-model="by"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Item activity', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <v-autocomplete label="Activity" dense outlined :items="activityTypes" v-model="activityType" hide-details @change="refresh()"/>
        </v-col>
        <v-col cols="3" v-if="sites.length>1">
          <v-autocomplete label="Site" dense outlined hide-details :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="siteId" item-text="name" item-value="id" @change="refresh()"/>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 228px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'
import {add,format} from 'date-fns';

export default {
  name: 'ReportsItemsActivity',
  mixins: [printHtml],
  components: {InventoryCategoriesSelect},
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      siteId: null,
      show: 'Quantity',
      by: 'Date',
      categoryId: null,
      loading: true,
      start: [],
      end: [],
      transactions: [],
      activityTypes: [{text:'All',value:null},{divider:true},{text:'Initial',value:'ItemTransactionInitial'},{text:'Adjust inventory',value:'ItemTransactionAdjustInventory'},
                      {text:'Mash',value:'Mash'},{text:'Distillation',value:'Distillation'},{text:'Bottling',value:'Bottling'},
                      {text:'Transfer site',value:'ItemTransactionTransferSite'},{text:'Inventory receipt',value:'Receipt'},{text:'Assemble',value:'Assembly'}
                      ],
      activityType: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true);
    }
  },
  async created() {
    this.$emit('name', 'Items activity')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.start = [];
      this.end = [];
      await Promise.all([
        this.$lazyListLoad(this.start, 'items2',
                          'id,name,trackUnits,precision,sites {siteId,quantity,value}', 100,
                          [],[{name:'asof', value:format(add(new Date(this.from+'T23:59:59'), {days:-1}),'yyyy-MM-dd HH:mm:ss')}]),
        this.$lazyListLoad(this.end, 'items2',
                          'id,sites {siteId,quantity,value}', 100,
                          [],[{name:'asof',value:`${this.to} 23:59:59`}])
      ]);
      const results = await this.$apiCall(`query ReportsItemsActivity($from:Date!,$to:Date!,$siteId:ID, $refType:ObjectType, $categoryId:ID) {
                                                itemsActivity(from:$from,to:$to,siteId:$siteId,refType:$refType,categoryId:$categoryId) {
                                                  date,itemId,description,quantity,trackUnits,itemName,precision,value
                                                }
                                              }`,
                                          {from:this.from,to:this.to,siteId:this.siteId,refType:this.activityType,categoryId:this.categoryId});
      if (!results.error)
        this.transactions = results.data.itemsActivity;
      this.loading = false;
    },

    report() {
      const lines = [
                  `<style>
                    @page {size:landscape}
                    .reports-items-activity {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .reports-items-activity th {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-items-activity .spacer {height:18px}
                    .reports-items-activity td {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-items-activity .title {font-size:18px;text-transform:uppercase}
                    .reports-items-activity .sup-title {font-weight:normal;font-size:22px}
                    .reports-items-activity .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .reports-items-activity .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .reports-items-activity .text-left {text-align:left}
                    .reports-items-activity .text-right {text-align:right}
                    .reports-items-activity .font-weight-bold {font-weight:bold}
                    .reports-items-activity .total-row {font-weight:bold}
                    .reports-items-activity .capitalize {text-transform: capitalize}
                  </style>
                   <table class="reports-items-activity">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">Items activity</th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                        <tr class="header">
                          ${this.by=='Date'?'<th width="15%" class="text-left">Date</th><th width="30%" class="text-left">Item</th>':'<th width="30%" class="text-left">Item</th><th width="15%" class="text-left">Date</th>'}
                          <th width="40%" class="text-left">Activity</th>
                          <th width="15%" class="text-right">${this.show}</th>
                        </tr>
                      </thead>
                      <tbody>`
    ];
    const transactions = [...this.transactions].sort((a,b) => {
      if (this.by === 'Date' || a.itemName === b.itemName)
        return a.date > b.date ? 1 : -1;
      else
        return a.itemName > b.itemName ? 1 : -1;
    });
    let itemId;
    let precision;
    let trackUnits;
    for (const transaction of transactions) {
      lines.push(`<tr>`);
      if (this.by === 'Item' && itemId !== transaction.itemId) {
        if (itemId) {
          lines.push(`<td colspan="2"></td>`);
          lines.push(`<td class="text-left font-weight-bold">Closing balance</td>`);
          if (this.show === 'Quantity')
            lines.push(`<td class="text-right">${this.$number(this.total(this.end, itemId).quantity,precision)} ${trackUnits}</td>`);
          else
            lines.push(`<td class="text-right">$${this.$number(this.total(this.end, itemId).value,2)}</td>`);
          lines.push(`</tr><tr>`);
        }
        itemId = transaction.itemId;
        precision = transaction.precision;
        trackUnits = transaction.trackUnits;
        lines.push(`<td colspan="2" class="text-left font-weight-bold">${transaction.itemName}</td>`);
        lines.push(`<td class="text-left font-weight-bold">Opening balance</td>`)
        if (this.show === 'Quantity')
          lines.push(`<td class="text-right">${this.$number(this.total(this.start, itemId).quantity,transaction.precision)} ${transaction.trackUnits}</td>`);
        else
          lines.push(`<td class="text-right">$${this.$number(this.total(this.start, itemId).value,2)}</td>`);
        lines.push(`</tr><tr>`);
      }
      if (this.by === 'Date') {
        lines.push(`<td>${this.$formatDate(transaction.date)}</td>`);
        lines.push(`<td class="text-left">${transaction.itemName}</td>`);
      } else {
        lines.push(`<td/>`);
        lines.push(`<td>${this.$formatDate(transaction.date)}</td>`);
      }
      lines.push(`<td>${transaction.description}</td>`);
      if (this.show === 'Quantity')
        lines.push(`<td class="text-right">${this.$number(transaction.quantity,transaction.precision)} ${transaction.trackUnits}</td>`);
      else
        lines.push(`<td class="text-right">$${this.$number(transaction.value,2)}</td>`);
      lines.push(`</tr>`);
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },

    total(itemList, itemId) {
      const sites = itemList.find(item => item.id === itemId).sites;
      return sites.reduce(({quantity,value},site) => {
        if (!this.siteId || this.siteId === site.siteId)
          return {quantity: quantity + site.quantity, value: value + site.value};
        return {quantity,value};
      }, {quantity:0,value:0});
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,`,
                      `"Items activity",,,`,
                      `"${this.dateDisplay}",,,`,
                      `"Date","Activity","Item","${this.show}"${this.show==='Quantity'?`,"UOM"`:''}`
                    ];
      for (const transaction of this.transactions)
        if (this.show === 'Quantity')
          lines.push(`"${transaction.date}","${transaction.description}","${transaction.itemName}","${this.$number(transaction.quantity,transaction.precision)}","${transaction.trackUnits}"`);
        else
          lines.push(`"${transaction.date}","${transaction.description}","${transaction.itemName}","${this.$number(transaction.value,2)}"`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Items activity.csv');
    }
  }
}
</script>